module.exports = __webpack_public_path__ + "static/media/paperTaxInvoiceTaxSample.ab694c07.xls";